export const SET_ADBLOCK = 'SET_ADBLOCK';

export const setAdBlock = detected => ({
  type: SET_ADBLOCK,
  detected,
});



// WEBPACK FOOTER //
// ./src/actions/adblock.js